import _get from "lodash";
const SearchHistoryParser = {};
SearchHistoryParser.getSearchHistoryParser = (res) => {
  if (!res) {
    return {};
  }

  if (res) {
    const data = res?.result;
    return data
  }
};  



export { SearchHistoryParser };